export default __webpack_public_path__ + "static/media/Hand_right.6f182973.svg";